export default __webpack_public_path__ + "static/media/hope-isialnd-website.9aa0dd3c.jpg";